<!-- Header moved inside main container -->

<div class="row justify-content-center">
    <div class="col-12 col-xl-8">
        <!-- New Header Layout -->
        <div class="mb-4 position-relative">
            <div class="d-flex justify-content-center align-items-center mb-2 position-relative">
                <button *ngIf="canEditBank"
                    class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2 position-absolute start-0 top-0"
                    (click)="cancel()">
                    <span class="material-symbols-outlined" style="font-size: 18px;">arrow_back</span>
                </button>
                <div class="d-flex align-items-center gap-2">
                    <span class="material-symbols-outlined fs-4">account_balance</span>
                    <h1 class="h4 mb-0">{{ isEditMode ? 'Editar' : 'Crear' }} <strong
                            class="fw-semibold text-colonial">Banco</strong></h1>
                </div>
            </div>
            <p class="text-muted text-center mx-auto mb-0" style="max-width: 520px;">
                {{ isEditMode ? 'Edita la información del banco y gestiona sus sucursales.' : 'Ingresa la información
                del nuevo banco.' }}
            </p>
        </div>

        <!-- Bank Form Card: renaming/creating banks stays with La Colonial -->
        <div *ngIf="canEditBank" class="card shadow-sm border-0 overflow-hidden rounded-4 mb-4">
            <div class="card-header bg-white py-3">
                <h3 class="h5 mb-0 d-flex gap-2 align-items-center">
                    <span class="material-symbols-outlined text-colonial">edit</span>
                    <span>Información del Banco</span>
                </h3>
            </div>
            <div class="card-body">
                <form [formGroup]="form" (ngSubmit)="onSubmit()">
                    <div class="mb-3">
                        <label for="bankName" class="form-label">Nombre del Banco <span
                                class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="bankName" formControlName="name"
                            placeholder="Ingresa el nombre del banco">
                        <div *ngIf="form.get('name')?.invalid && form.get('name')?.touched"
                            class="text-danger mt-1 small">
                            El nombre es requerido.
                        </div>
                    </div>

                    <div class="d-flex gap-2 justify-content-end">
                        <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
                        <button type="submit" class="btn bg-colonial btn-secondary">
                            {{ isEditMode ? 'Actualizar' : 'Crear' }} Banco
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <!-- Regions Section (only in edit mode) -->
        <div *ngIf="isEditMode" class="card shadow-sm border-0 overflow-hidden rounded-4 mb-4">
            <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
                <h3 class="h5 mb-0 d-flex gap-2 align-items-center">
                    <span class="material-symbols-outlined text-colonial">map</span>
                    <span>Regiones</span>
                </h3>
                <button (click)="openAddRegionModal()"
                    class="btn bg-colonial btn-secondary btn-sm d-flex align-items-center gap-1" type="button">
                    <span class="material-symbols-outlined" style="font-size: 18px;">add</span>
                    Nueva Región
                </button>
            </div>
            <div class="card-body">
                <div *ngIf="regions.length === 0" class="text-muted text-center py-4">
                    No hay regiones. Crea una para agrupar sucursales y asignarlas a usuarios regionales.
                </div>

                <table *ngIf="regions.length > 0" class="table table-hover mb-0">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Sucursales</th>
                            <th class="text-end">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let region of regions">
                            <td>{{ region.name }}</td>
                            <td>{{ region.branchCount }}</td>
                            <td class="text-end">
                                <div class="d-flex gap-2 justify-content-end">
                                    <button (click)="openEditRegionModal(region)"
                                        class="btn btn-sm btn-outline-secondary" type="button" title="Renombrar">
                                        <span class="material-symbols-outlined" style="font-size: 18px;">edit</span>
                                    </button>
                                    <button (click)="deleteRegion(region)" class="btn btn-sm btn-outline-danger"
                                        type="button" title="Eliminar">
                                        <span class="material-symbols-outlined" style="font-size: 18px;">delete</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <p class="text-muted small mb-0 mt-3">La región de cada sucursal se asigna al editar la sucursal.</p>
            </div>
        </div>

        <!-- Branches Section (only in edit mode) -->
        <div *ngIf="isEditMode" class="card shadow-sm border-0 overflow-hidden rounded-4">
            <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
                <h3 class="h5 mb-0 d-flex gap-2 align-items-center">
                    <span class="material-symbols-outlined text-colonial">store</span>
                    <span>Sucursales</span>
                </h3>
                <button (click)="openAddBranchModal()"
                    class="btn bg-colonial btn-secondary btn-sm d-flex align-items-center gap-1" type="button">
                    <span class="material-symbols-outlined" style="font-size: 18px;">add</span>
                    Nueva Sucursal
                </button>
            </div>

            <!-- Branches Table -->
            <div class="card-body">
                <div *ngIf="branches.length === 0" class="text-muted text-center py-4">
                    No hay sucursales registradas para este banco.
                </div>

                <table *ngIf="branches.length > 0" class="table table-hover mb-0">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Región</th>
                            <th class="text-end">Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let branch of branches">
                            <td>{{ branch.name }}</td>
                            <td>{{ branch.regionName || regionName(branch.regionId) }}</td>
                            <td class="text-end">
                                <div class="d-flex gap-2 justify-content-end">
                                    <button (click)="openEditBranchModal(branch)"
                                        class="btn btn-sm btn-outline-secondary" type="button">
                                        <span class="material-symbols-outlined" style="font-size: 18px;">edit</span>
                                    </button>
                                    <button (click)="deleteBranch(branch.id)" class="btn btn-sm btn-outline-danger"
                                        type="button">
                                        <span class="material-symbols-outlined" style="font-size: 18px;">delete</span>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- Branch Modal -->
<app-branch-modal *ngIf="showBranchModal" [branch]="editingBranch" [isVisible]="showBranchModal" [regions]="regions"
    (closed)="onBranchModalClosed($event)">
</app-branch-modal>

<app-region-modal *ngIf="showRegionModal" [region]="editingRegion"
    (closed)="onRegionModalClosed($event)"></app-region-modal>